import { render, staticRenderFns } from "./Html.global.vue?vue&type=template&id=6454df35&lang=pug&"
import script from "./Html.global.vue?vue&type=script&lang=ts&"
export * from "./Html.global.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports